import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
import { useCallback, useEffect, useState } from 'react';
import { useCarouselCommonContext } from "../context";
export var useCarouselNavigationButtons = function useCarouselNavigationButtons() {
  var _useCarouselCommonCon = useCarouselCommonContext(),
    swiperInstance = _useCarouselCommonCon.swiperInstance,
    loop = _useCarouselCommonCon.loop;
  var _useState = useState(loop),
    _useState2 = _slicedToArray(_useState, 2),
    isPrevBtnEnable = _useState2[0],
    setIsPrevBtnEnable = _useState2[1];
  var _useState3 = useState(true),
    _useState4 = _slicedToArray(_useState3, 2),
    isNextBtnEnable = _useState4[0],
    setIsNextBtnEnable = _useState4[1];
  useEffect(function () {
    if (!swiperInstance) return;
    var handleReachBeginning = function handleReachBeginning() {
      if (loop) return;
      setIsPrevBtnEnable(false);
      setIsNextBtnEnable(true);
    };
    var handleReachEnd = function handleReachEnd() {
      if (loop) return;
      setIsPrevBtnEnable(true);
      setIsNextBtnEnable(false);
    };
    var handleSlideChange = function handleSlideChange(swiper) {
      if (loop) {
        setIsNextBtnEnable(true);
        setIsPrevBtnEnable(true);
        return undefined;
      }

      // Edge case: если только один слайд
      if (swiper.slides.length <= 1) {
        setIsNextBtnEnable(false);
        setIsPrevBtnEnable(false);
        return undefined;
      }
      if (swiper.isBeginning) {
        handleReachBeginning();
        return undefined;
      }
      if (swiper.isEnd) {
        handleReachEnd();
        return undefined;
      }
      setIsPrevBtnEnable(true);
      setIsNextBtnEnable(true);
      return undefined;
    };
    swiperInstance.on('slideChange', handleSlideChange);
    swiperInstance.on('reachEnd', handleReachEnd);
    swiperInstance.on('reachBeginning', handleReachBeginning);

    // eslint-disable-next-line consistent-return
    return function () {
      swiperInstance.off('slideChange', handleSlideChange);
      swiperInstance.off('reachEnd', handleReachEnd);
      swiperInstance.off('reachBeginning', handleReachBeginning);
    };
  }, [swiperInstance, loop]);
  var handlePrevSlide = useCallback(function () {
    if (swiperInstance !== null && swiperInstance !== void 0 && swiperInstance.isBeginning) {
      swiperInstance.slideToLoop(swiperInstance.slides.length - 1);
    }
    swiperInstance === null || swiperInstance === void 0 ? void 0 : swiperInstance.slidePrev();
  }, [swiperInstance]);
  var handleNextSlide = useCallback(function () {
    if (swiperInstance !== null && swiperInstance !== void 0 && swiperInstance.isEnd) {
      swiperInstance.slideToLoop(0);
    }
    swiperInstance === null || swiperInstance === void 0 ? void 0 : swiperInstance.slideNext();
  }, [swiperInstance]);
  return {
    isPrevBtnEnable: isPrevBtnEnable,
    isNextBtnEnable: isNextBtnEnable,
    handlePrevSlide: handlePrevSlide,
    handleNextSlide: handleNextSlide
  };
};